// Modules
import React, { useEffect, useState } from 'react'
import { Icon, Loading } from '@dasa-health/components-react'
import { SystemBoldRoundcheckon, SystemBoldWarning } from '@dasa-health/icons'

// Component
import { StyledStatusBar } from './styles'

interface Props {
    status: string
    message: string
}

export const StatusBar: React.FC<Props> = props => {
    const { status, message } = props
    const [text, setText] = useState('')
    const [icon, setIcon] = useState(<span />)

    useEffect(() => {
        if (status) {
            setText(message)
            if (status === 'loading') {
                setIcon(<Loading data-testid="statusbar-loading" size={12} />)
            }
            if (status === 'success') {
                setIcon(
                    <Icon data-testid="statusbar-success" sx={{ padding: 0 }}>
                        <SystemBoldRoundcheckon />
                    </Icon>,
                )
            }
            if (status === 'error') {
                setIcon(
                    <Icon data-testid="statusbar-error" sx={{ padding: 0 }}>
                        <SystemBoldWarning />
                    </Icon>,
                )
            }
        }
    }, [status, message])

    return (
        <StyledStatusBar {...props}>
            {icon}
            <p data-testid="statusbar-text">{text}</p>
        </StyledStatusBar>
    )
}
